@if (data$ | async) {
  <ng-container>

    <mat-table
      #table
      [trackBy]="trackBy"
      class="__table"
      [class.has-state]="!!itemStateTemplate"
      matSort
      [matSortActive]="defaultSort"
      [matSortDirection]="defaultSortDirection"
      (matSortChange)="sorted$.next($event); sorted.emit($event)"
      [dataSource]="dataSource">

      @for (col of columns; let index = $index; track index) {
        <ng-container [matColumnDef]="col.name">

          <mat-header-cell
            mat-sort-header
            [arrowPosition]="col.headerAlign === 'right' ? 'before' : 'after'"
            [ngClass]="{
              'is-right': col.headerAlign === 'right',
              'is-center': col.headerAlign === 'center'
            }"
            [disabled]="!col.enableSort || (!col.sort && !col.dataPath)"
            [ngStyle]="{
              'width': col.width || 'auto',
              'min-width': col.minWidth || 'auto',
              'max-width': col.maxWidth || 'auto'
            }"
            *matHeaderCellDef>
            <span [class]="'__header-cell--' + col.name">
              {{
              colsTranslations?.[col.translate] !== undefined
              ? colsTranslations?.[col.translate]
              : col.name
              }}
            </span>
          </mat-header-cell>

          <mat-cell
            class="__cell"
            [class.has-link]="!col.disableLink && !!linkPath"
            [ngStyle]="{
              'width': col.width || 'auto',
              'min-width': col.minWidth || 'auto',
              'max-width': col.maxWidth || 'auto'
            }"
            (click)="clickRow(element, $event); navigate(linkPath, element.id, col.disableLink);"
            *matCellDef="let element">

            @if (col.type === colTypes.custom && columnTemplateMap[col.name]) {
              <ng-template
                [ngTemplateOutletContext]="{ $implicit: element }"
                [ngTemplateOutlet]="columnTemplateMap[col.name]">
              </ng-template>
            } @else {
              @switch (col.type) {
                @case (colTypes.date) {
                  <span class="__date">
                    {{ (element | getPropByString: col.dataPath | translocoDate: { dateStyle: 'medium' }) || '-' }}
                  </span>
                }
                @case (colTypes.boolean) {
                  {{ (element | getPropByString: col.dataPath) ? 'Yes' : 'No' }}
                }
                @default {
                  {{ (element | getPropByString: col.dataPath) || '-' }}
                }
              }
            }


          </mat-cell>

        </ng-container>
      }

      <mat-header-row
        class="__header"
        *matHeaderRowDef="colNames">
      </mat-header-row>

      <div
        [class]="'__row-wrap' + (customClassProperty ? ' __custom-row-class_' + row[customClassProperty] : '')"
        [class.has-hover]="!disableHover"
        *matRowDef="let row; columns: colNames">

        <mat-row class="__row"></mat-row>

        @if (actionsTemplates && actionsTemplates.length) {
          <div
            class="__actions"
            fxLayout="row"
            fxLayoutAlign="end center"
            fxLayoutGap="12px"
            [hidden]="!actionsRef.clientWidth"
            #actionsRef>
            @for (template of actionsTemplates; let index = $index; track index) {
              <ng-container>
                <ng-template
                  [ngTemplateOutlet]="template"
                  [ngTemplateOutletContext]="{ $implicit: row }">
                </ng-template>
              </ng-container>
            }
          </div>
        }

        @if (itemStateTemplate) {
          <div
            class="__item-state"
            >
            <ng-template
              #stateRef
              [ngTemplateOutlet]="itemStateTemplate"
              [ngTemplateOutletContext]="{ $implicit: row }">
            </ng-template>
          </div>
        }

      </div>

    </mat-table>

    <div class="__paginator-wrap">
      @if (paginatorLength > paginatorPageSize) {
        <mat-paginator
          class="__paginator"
          hidePageSize
          [pageIndex]="(currentPage$ | async) - 1"
          [length]="paginatorLength"
          [pageSize]="paginatorPageSize"
          (page)="page.emit($event)">
        </mat-paginator>
      }
    </div>

  </ng-container>
}
